import { useCallback, useState } from 'react';
import { Link } from 'react-router';
import { Button, Field, Input } from '@mgdlead/ui';

import { AuthLayout } from '../../components/AuthLayout';
import { FormAlert } from '@mgdlead/ui';
import { requestPasswordReset } from '../../lib/auth';
import { forgotPasswordSchema } from '../../lib/schemas';
import type { ForgotPasswordValues } from '../../lib/schemas';
import { useDocumentTitle } from '../../lib/useDocumentTitle';
import { useZodForm } from '../../lib/useZodForm';

const INITIAL: ForgotPasswordValues = { email: '' };

export function ForgotPasswordPage() {
  useDocumentTitle('Recuperar senha');
  const [sent, setSent] = useState(false);

  const onSubmit = useCallback(async (values: { email: string }) => {
    await requestPasswordReset(values.email);
    setSent(true);
  }, []);

  const form = useZodForm({ schema: forgotPasswordSchema, initialValues: INITIAL, onSubmit });

  return (
    <AuthLayout
      title="Recuperar senha"
      description="Informe o e-mail da conta. Se ele existir, enviamos um link para criar uma senha nova."
      footer={
        <Link
          to="/login"
          className="font-medium text-primary-text underline-offset-4 hover:underline"
        >
          Voltar para entrar
        </Link>
      }
    >
      {sent ? (
        /*
         * Resposta idêntica para e-mail que existe e para o que não existe:
         * dizer "essa conta não existe" entrega quem é cliente do produto.
         */
        <FormAlert tone="success">
          Se houver uma conta com esse e-mail, o link de redefinição chega em instantes. Ele vale
          por tempo limitado e só pode ser usado uma vez.
        </FormAlert>
      ) : (
        <form noValidate onSubmit={form.handleSubmit} className="flex flex-col gap-4">
          {form.formError ? <FormAlert>{form.formError}</FormAlert> : null}

          <Field label="E-mail" error={form.errors.email} required>
            {(control) => (
              <Input
                {...control}
                type="email"
                name="email"
                autoComplete="email"
                inputMode="email"
                autoCapitalize="none"
                spellCheck={false}
                placeholder="voce@empresa.com"
                value={form.values.email}
                invalid={form.errors.email !== undefined}
                onChange={(event) => form.setField('email', event.target.value)}
              />
            )}
          </Field>

          <Button
            type="submit"
            variant="dark" size="lg"
            block
            loading={form.pending}
            loadingLabel="Enviando link"
          >
            Enviar link
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
